/* cSpell:disable */
import { Quote } from '@tenants/types/tenant';
import { LOCALE_EXP_COMMERCIAL_PATHS } from 'types/locales';

/**
 * Create a quote config for the commercial tenant with the given namespace, highlight color, and span class name override.
 * @param highlightColor The color of the highlight.
 * @param spanClassName The class name of the span element to override the default styles for the quote content.
 * @returns A quote config for the commercial tenant.
 */
export function createQuoteConfig(highlightColor: string, spanClassName: string): Quote {
  const leoParejaQuote: Quote = {
    authorImage: '/next/assets/images/join-expus/Leo.jpg',
    authorImageAlt: 'Leo Pareja',
    authorTitle: LOCALE_EXP_COMMERCIAL_PATHS.LEOQUOTE_AUTHORTITLE,
    authorName: 'Leo Pareja',
    quoteContent: LOCALE_EXP_COMMERCIAL_PATHS.LEOQUOTE_QUOTECONTENT,
    className: { span: spanClassName },
    highlightColor,
  } as const;

  return leoParejaQuote;
}